import { defineComponent as _defineComponent } from 'vue'


interface Props {
	/**
	 * 「追加表示ボタン内部」文言
	 */
	moreButtonDisplayName: string;
	/**
	 * リプライの追加表示APIリクエスト中かどうか。
	 */
	isProcessingGetMoreReply: boolean;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars, no-undef
interface Emits {
	(e: "on-click-more-button"): void;
}

export default /*#__PURE__*/_defineComponent({
  props: {
    moreButtonDisplayName: { type: String, required: true },
    isProcessingGetMoreReply: { type: Boolean, required: true }
  },
  emits: ["on-click-more-button"],
  setup(__props: any, { expose, emit }: { emit: ({
	(e: "on-click-more-button"): void;
}), expose: any, slots: any, attrs: any }) {
  expose()

const props = __props as {
	/**
	 * 「追加表示ボタン内部」文言
	 */
	moreButtonDisplayName: string;
	/**
	 * リプライの追加表示APIリクエスト中かどうか。
	 */
	isProcessingGetMoreReply: boolean;
}
/**
 * リプライ追加表示ボタン。
 */




const onclick = (): void => {
	emit("on-click-more-button");
};

const __returned__ = { props, emit, onclick }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})